import { formatMoney } from "../../../utils";

const TotalCard = ({ jobRatePreHour, isHome = false }) => (
    <div className={`card bg-gradient-dark ${!isHome && 'mx-3'} text-white`}>
        <div className="card-body p-3 position-relative">
            <div className="row mt-2">
                <div className="col-7 text-start">
                    <p className="text-xl mb-1 text-capitalize font-weight-bold">Total</p>
                </div>
                <div className="col-5 text-end">
                    <h6 className="font-weight-bolder mb-0 text-white">
                        {formatMoney(jobRatePreHour?.total ?? 0)}
                    </h6>
                </div>
            </div>
        </div>
    </div>
);

export default TotalCard;